<template>
    <div>
        <h1 class="display-heading">Company Tiers</h1>
        <div v-for="(tier, index) in list" class="card mb-3" :key="index">
            <div class="card-header">
                {{ tier.tier.tierName }}
            </div>
            <div class="card-body">
                <div v-for="(tierBenefit, index2) in tier.list" :key="index2">
                    <div>
                        <p>{{ index2 + 1 }}. {{ tierBenefit.permissibleCategory.name }}
                        </p>
                        <ul>
                            <li v-for="(item, index3) in tierBenefit.permissibleItems" :key="index3">
                            {{ item.name }}
                        </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    'name': 'AdminViewCompanyTierDetail',
    'computed': {
        companyId () {
            return this.$route.params.id;
        }
    },
    data () {
        return {
            'list': []
        };
    },
    'methods': {
        getCompanyTiers () {
            this.axios.get(`Debug/Tier/Company/${this.companyId}`).then(({ data }) => {
                const list = data;
                if (list) {
                    this.list = data;
                }
            });
        }
    },
    mounted () {
        if (this.companyId) {
            this.getCompanyTiers();
        }
    }
};
</script>
